import Vue from "vue";
import Vuex from "vuex";
import tab from "./tab";
import message from "./message";
import { refresh,getPigToken } from "@/api/index.js"

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: sessionStorage.getItem("user_token") || "",
        MT:{},
        pigConfig:{},
        MT_token: localStorage.getItem("accessToken"),
        userInfo: sessionStorage.getItem("userInfo") || {},
        MTConfig:{},
    },
    mutations: {
        setUser(state, data) {
            // console.log(state, data);
            state.user = data;
            sessionStorage.setItem("user_token", state.user);
        },
        setUserInfo(state, data) {
            sessionStorage.setItem('userInfo',JSON.stringify(data))
            state.userInfo = data;
        },
        setPigConfig(state){
            let pigConfig = sessionStorage.getItem("pigConfig");
            if(pigConfig){
                pigConfig = JSON.parse(pigConfig);
                let dateTime = new Date().getTime();
                let end_time = pigConfig?.expiresAt;
                //当前时间戳对比美团token失效时间戳
                if(dateTime >= end_time){
                    execute()
                }else{
                    state.pigConfig = pigConfig;
                    sessionStorage.setItem("pigConfig", JSON.stringify(pigConfig));
                }
            }else{
                execute()
            }
            function execute(){
                //刷新小猪token令牌
                getPigToken().then(result => {
                    if(result.data.code === 200){
                        state.pigConfig = result.data.data;
                        sessionStorage.setItem("pigConfig", JSON.stringify(result.data.data));
                    }
                })
            }
        },
        setMTConfig(state,value){
            console.log(value)
            state.MTConfig=value;
            let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            localStorage.setItem('mtConfig-'+userInfo.userId,JSON.stringify(value));
        },
        setMT(state) {
            //获取美团的token
            let MT = sessionStorage.getItem("MT");
            if(MT){
                MT = JSON.parse(MT);
                let dateTime = new Date().getTime();
                let end_time = MT?.expiresAt;
                //当前时间戳对比美团token失效时间戳
                if(dateTime >= end_time){
                    execute()
                }else{
                    state.MT = MT;
                    sessionStorage.setItem("MT", JSON.stringify(MT));
                }
            }else{
                execute()
            }
            function execute(){
                //刷新美团token令牌
                refresh().then(result => {
                    if(result.data.code === 200){
                        state.MT = result.data.data;
                        sessionStorage.setItem("MT", JSON.stringify(result.data.data));
                    }
                })
            }
        },
        setMtToken(state,value){
            state.MT_token = value;
            localStorage.setItem('accessToken',value)
        }
    },
    actions: {},
    modules: {
        tab,
        message
    }
});
